import React from 'react';
import './../less/pbp.less';
import hero_img from '../img/pbp/hero_img.png';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";
import FAQStorybook from '@abank/abank-faq';
import how_to_block_img_1 from '../img/pbp/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/pbp/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/pbp/how_to_block_img_3.png';
import how_to_block_img_4 from '../img/pbp/how_to_block_img_4.png';
import how_to_block_img_5 from '../img/pbp/how_to_block_img_5.png';
import how_to_block_img_6 from '../img/pbp/how_to_block_img_6.png';
import advantages_img_1 from '../img/pbp/advantages_img_1.png';
import advantages_img_2 from '../img/pbp/advantages_img_2.png';
import advantages_img_3 from '../img/pbp/advantages_img_3.png';
import advantages_img_4 from '../img/pbp/advantages_img_4.png';
import advantages_img_5 from '../img/pbp/advantages_img_5.png';
import advantages_img_6 from '../img/pbp/advantages_img_6.png';
import HowToBlockNew from '../../../auxiliary-components/shared/HowToBlockNew';
import tariffsData1 from '../enums/pbp/tariffs_data_01.json';
import tariffsData2 from '../enums/pbp/tariffs_data_02.json';
import additionalCards from '../enums/pbp/additional_cards_data.json';
import how_to_block_items_01 from '../enums/pbp/how_to_block_items_01.json';
import how_to_block_items_02 from '../enums/pbp/how_to_block_items_02.json';
import TextAboveFooterNew from '../../../auxiliary-components/shared/TextAboveFooterNew';
import advantages_items_01 from '../enums/pbp/advantages_items_01.json';
import advantages_items_02 from '../enums/pbp/advantages_items_02.json';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock';
import CalculatorNew from '../../../auxiliary-components/CalculatorNew';
import { Preloader } from 'MWComponents';
import MoreSliderBlock from './../../../auxiliary-components/shared/MoreSliderBlock';
import { buildPartnersSlides } from '../helper/buildPartnerSlides';
import partners_arrow from '../img/pbp/partners_arrow.svg';
import { ReactSVG } from 'react-svg';
import { buildPartnersGrouped } from '../helper/buildPartnersGrouped';
import DOMPurify from 'utils/sanitize';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import { canUseDOM } from '../../../helpers/canUseDOM';

export default function template() {
    const page = 'pbp-new';

    const tabs = [{tab: 'pbp', title: 'PBP_NEW_TABS_TITLE_01'},
          {tab: 'installment', title: 'PBP_NEW_TABS_TITLE_02'}];

    const hero_data = {
      title: 'PBP_NEW_HERO_TITLE',
      text: 'PBP_NEW_HERO_TEXT'
    }

    const imagesMap = {
      how_to_block_img_1,
      how_to_block_img_2,
      how_to_block_img_3,
      how_to_block_img_4,
      how_to_block_img_5,
      how_to_block_img_6,
      advantages_img_1,
      advantages_img_2,
      advantages_img_3,
      advantages_img_4,
      advantages_img_5,
      advantages_img_6
    };

    const mapItemsWithImages = (items) => items.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const howToBlockItems1 = mapItemsWithImages(how_to_block_items_01);
    const howToBlockItems2 = mapItemsWithImages(how_to_block_items_02);
    const advantagesItems1 = mapItemsWithImages(advantages_items_01);
    const advantagesItems2 = mapItemsWithImages(advantages_items_02);

    const pbpQuestionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');
    const installmentQuestionsWidget = this.widgetsHelper.getWidgetFrom.call(this, 'widgets_2', 'questions');

    const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');
    const partnersSlides = buildPartnersSlides(partnersWidget, this.state.environment);
    const partnersGrouped = buildPartnersGrouped(this.state.partnersData);

    const partnersTabs = partnersGrouped.map(category => ({
      tab: `partner-${category.category_id}`,
      title: category.title
    }));

    const renderPartnersSlider = (swiperRef) => {
      if (partnersSlides && partnersSlides.length > 0) {
        return (
          <MoreSliderBlock
            swiperRef={swiperRef}
            items={partnersSlides}
            className={"partners-slider"}
            title={'PBP_NEW_PARTNERS_TITLE'}
            groupSize={8}
            slidesPerView={1}
            spaceBetween={8}
            controlsBelowOnMobile={true}
            btnText={'PBP_NEW_PARTNERS_BTN_TEXT_1'}
            btnId={`${page} partners-btn`}
            btnLink={"/business/pbp-entity"}
            renderSlide={(item, index) => {
              if (item.type === 'all-partners') {
                return (
                  <button
                    key={index}
                    className="item-more-slider__all-partners"
                    onClick={this.toggleAllPartnersTab}
                    id={`${page} all-partners-btn`}
                  >
                    <div className="item-more-slider__text">{this.l10n('PBP_NEW_PARTNERS_BTN_TEXT_2')}</div>
                    <ReactSVG
                      src={partners_arrow}
                      className="item-more-slider__arrow"
                    />
                  </button>
                );
              }

              return (
                <a
                  key={index}
                  className="item-more-slider__link"
                  href={item.file_path}
                  target="_blank"
                >
                  <img className="item-more-slider__image" src={item.img_desktop} alt={DOMPurify.sanitize(item.title, {
                    ALLOWED_TAGS: [],
                    ALLOWED_ATTR: []
                  })}/>
                  <div className="item-more-slider__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title)}}></div>
                </a>
              );
            }}
          />
        );
      }
      return canUseDOM ? <Preloader /> : null;
    };

    const renderTabContent = ({className, tariffsData, advantagesItems, model, calcType, howToBlockItems, questionsWidget, swiperRef}) => (
      <div className={className}>
        <Tariffs
          items={tariffsData}
          title={'PBP_NEW_TARIFFS_TITLE'}
        />
        <Advantages
          items={advantagesItems}
          title={'PBP_NEW_ADVANTAGES_TITLE'}
        />
        {renderPartnersSlider(swiperRef)}
        {model ? (
          <CalculatorNew
            tab={this.state.tab}
            model={model}
            type={calcType}
            {...this.props}
          />
        ) : (canUseDOM ? <Preloader /> : null)}
        <HowToBlockNew
          title={'PBP_NEW_HOW_TO_BLOCK_TITLE'}
          items={howToBlockItems}
        />
        <AdditionalProduct
          items={additionalCards}
          title={'PBP_NEW_ADDITIONAL_PRODUCT_TITLE'}
          page={page}
        />
        <QuestionsAdminNew
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'PBP_NEW_QUESTIONS_ADMIN_TITLE'}
          page={page}
        />
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
        />
        <TextAboveFooterNew
          widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
        />
      </div>
    );

    return (
      <div className="pay-by-parts">
        <Hero
          data={hero_data}
          img={hero_img}
        />
        <div className={`content${(this.state.faqTab || this.state.partnersTab) ? ' hidden' : ''}`}>
          <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
            {renderTabContent({
              className: 'pbp-content',
              tariffsData: tariffsData1,
              advantagesItems: advantagesItems1,
              model: this.state.modelPbp,
              calcType: this.state.paymentPart,
              howToBlockItems: howToBlockItems1,
              questionsWidget: pbpQuestionsWidget,
              swiperRef: this.sliderRefPartners,
            })}
            {renderTabContent({
              className: 'installment-content',
              tariffsData: tariffsData2,
              advantagesItems: advantagesItems2,
              model: this.state.modelInstallment,
              calcType: this.state.installmentFromStatement,
              howToBlockItems: howToBlockItems2,
              questionsWidget: installmentQuestionsWidget,
              swiperRef: this.sliderRefPartnersInstallment,
            })}
          </Tabs>
        </div>
        <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
          <div className={this.state.tab !== 'pbp' ? 'faq-tab-hidden' : ''}>
            <FAQStorybook
                widget={pbpQuestionsWidget}
                title={this.l10n('PBP_NEW_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('PBP_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
            />
          </div>
          <div className={this.state.tab !== 'installment' ? 'faq-tab-hidden' : ''}>
            <FAQStorybook
                widget={installmentQuestionsWidget}
                title={this.l10n('PBP_NEW_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('PBP_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
            />
          </div>
        </div>
        <div className={`content${!this.state.partnersTab ? ' hidden' : ''}`}>
          {this.state.partnersData && this.state.partnersData.length > 0 ? (
              <Tabs
                tabs={partnersTabs}
                toggle={this.togglePartnerTab}
                tab={this.state.partnerTab}
                title={'PBP_NEW_ALL_PARTNERS_TITLE'}
                showArrows
              >
                {partnersGrouped.map(category => (
                  <div key={category.category_id} className="partners">
                    <div className="container">
                      <div className="partners__items">
                        {category.items.map(partner => (
                          <a
                            key={partner.id}
                            href={partner.site}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="partners__item item-partners"
                          >
                            <div className="item-partners__image">
                              <img
                                src={partner.logo_url}
                                alt={DOMPurify.sanitize(partner.name, {
                                  ALLOWED_TAGS: [],
                                  ALLOWED_ATTR: []
                                })}
                              />
                            </div>
                            <div className="item-partners__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(partner.name)}}></div>
                          </a>
                        ))}
                      </div>
                      <button
                        className="partners__btn"
                        onClick={this.toggleAllPartnersTab}
                      >
                        {this.l10n('PBP_NEW_ALL_PARTNERS_BTN_TEXT')}
                      </button>
                    </div>
                  </div>
                ))}
              </Tabs>
            ) : (canUseDOM ? <Preloader /> : null)
          }
        </div>
      </div>
    );
}
